import React, { useState, useEffect } from "react";
import "./Zatca.css";
import ZatcaIntegration from "./ZatcaIntegration";
import OnboardingOTP from "./OnboardingOTP";
import ZatPic from "../../../assets/images/zatca.png";
import { useParams } from "react-router-dom";
import { getUserById, toggleOnboard } from "../../../../redux/user/action";
import { useDispatch, useSelector } from "react-redux";
import Toast from "./Toast";

const OnboardingDetails = () => {
  const selectedUser = useSelector(({ user: { userbyid } }) => userbyid);
  const { id } = useParams();
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState(1);
  const [isPhase1Enabled, setIsPhase1Enabled] = useState(false);
  const [isPhase2Enabled, setIsPhase2Enabled] = useState(false);
  const [toasts, setToasts] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (selectedUser) {
      const phase1 =
        selectedUser.onboarding === 2 || selectedUser.onboarding === 0;
      const phase2 = selectedUser.onboarding === 1;

      if (phase1 && !isPhase1Enabled) {
        addToast("ZATCA Phase 1 has been enabled");
      }
      if (phase2 && !isPhase2Enabled) {
        addToast("ZATCA Phase 2 has been enabled");
      }

      setIsPhase1Enabled(phase1);
      setIsPhase2Enabled(phase2);
    }
  }, [selectedUser]);

  const addToast = (message) => {
    const newToast = {
      id: Date.now(),
      message: message,
    };
    setToasts((prevToasts) => [...prevToasts, newToast]);
  };

  const handleCloseToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  const handleToggleChange = () => {
    let newOnboardingStatus;

    if (selectedUser?.onboarding === 0) {
      newOnboardingStatus = 1;
    } else if (selectedUser?.onboarding === 1) {
      newOnboardingStatus = 2;
    } else {
      newOnboardingStatus = 1;
    }

    const data = {
      user_id: selectedUser?.user_id,
      onboarding: newOnboardingStatus,
    };
    dispatch(toggleOnboard(data, selectedUser?.id));
  };



const JsonViewer = ({ jsonData }) => {
  const [copied, setCopied] = useState(false);

  const containerStyle = {
    backgroundColor: "#f5f5f5",
    padding: "15px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    color: "#333",
    width: "80%",
    position: "relative",
  };

  const copyButtonStyle = {
    position: "absolute",
    right: "10px",
    top: "10px",
    padding: "5px 10px",
    background: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  };

  const handleCopy = () => {
    const jsonString = JSON.stringify(jsonData, null, 2);
    navigator.clipboard.writeText(jsonString);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Remove quotes from both keys and values
  const formatJsonWithoutQuotes = (obj) => {
    const jsonString = JSON.stringify(obj, null, 2);
    const lines = jsonString.split('\n').slice(1, -1); // Remove outer braces
    
    return lines.map(line => {
      // Remove quotes around keys and string values
      return line
        .replace(/^(\s*)"([^"]+)":/, '$1$2:')  // Remove key quotes
        .replace(/: "(.*?)"(,?)$/, ': $1$2');  // Remove value quotes
    }).join('\n');
  };


  return (
    <div style={containerStyle}>
      <button style={copyButtonStyle} onClick={handleCopy}>
        {copied ? 'Copied!' : 'Copy'}
      </button>
      <pre>{formatJsonWithoutQuotes(jsonData)}</pre>
    </div>
  );
};


  return (
    <div className="zatca-page-container">
      <div className="toast-container">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            onClose={() => handleCloseToast(toast.id)}
          />
        ))}
      </div>
      <h1 className="zatca-main-title">ZATCA Integration</h1>

      <div className="zatca-phase-card">
        <div className="zatca-phase-content">
          <div className="zatca-phase-logo-placeholder">
            <img
              src={ZatPic}
              alt="zatca"
              style={{ height: "70px", width: "70px" }}
            />
          </div>
          <div className="zatca-phase-text">
            <div className="zatca-phase-title">
              ZATCA Phase 1 – Generation Phase
            </div>
            <div className="zatca-phase-subtitle">
              Issuing digital invoices in compliance with ZATCA standards
            </div>
          </div>
        </div>
        <label className="switch">
          <input
            type="checkbox"
            checked={isPhase1Enabled}
            onChange={handleToggleChange}
            disabled={selectedUser?.onboarding === 0}
          />
          <span className="slider round"></span>
        </label>
      </div>

      {(selectedUser?.onboarding === 1 || selectedUser?.onboarding === 2) && (
        <div className="zatca-phase-card">
          <div className="zatca-phase-content">
            <div className="zatca-phase-logo-placeholder">
              <img
                src={ZatPic}
                alt="zatca"
                style={{ height: "70px", width: "70px" }}
              />
            </div>
            <div className="zatca-phase-text">
              <div className="zatca-phase-title">
                ZATCA Phase 2 – Integration Phase
              </div>
              <div className="zatca-phase-subtitle">
                Issuing digital invoices in compliance with ZATCA standards
              </div>
            </div>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              checked={isPhase2Enabled}
              onChange={handleToggleChange}
              disabled={selectedUser?.onboarding === 0}
            />
            <span className="slider round"></span>
          </label>
        </div>
      )}
      {(selectedUser?.onboarding === 1 || selectedUser?.onboarding === 2) && (
        <div className="container-card">
          <h3>The Properties</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <JsonViewer jsonData={selectedUser?.properties} />
          </div>
        </div>
      )}

      {selectedUser?.onboarding === 0 && (
        <div className="zatca-accordion">
          <div className="zatca-header" onClick={() => setIsOpen(!isOpen)}>
            <span>ZATCA Phase 2 – Integration Phase</span>
            <span className="zatca-icon">{isOpen ? "−" : "+"}</span>
          </div>
          {isOpen && (
            <div className="onboarding-content">
              <div className="stepper">
                <div className={`step ${activeStep === 1 ? "active" : ""}`}>
                  <div className="step-number">1</div>
                  <div className="step-title">
                    Onboarding Details
                    <div className="step-subtitle">
                      Enter your basic details
                    </div>
                  </div>
                </div>
                <div className={`step ${activeStep === 2 ? "active" : ""}`}>
                  <div className="step-number">2</div>
                  <div className="step-title">
                    Verify OTP and Start Integration
                    <div className="step-subtitle">
                      Confirm your OTP and start Integration
                    </div>
                  </div>
                </div>
              </div>

              {activeStep === 1 && (
                <ZatcaIntegration
                  setActiveStep={setActiveStep}
                  activeStep={activeStep}
                />
              )}
              {activeStep === 2 && <OnboardingOTP />}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OnboardingDetails;
